import Service, { service } from '@ember/service';

const quickPayRegex = /^([\d.]+)\s+(.*)/;

export default class QuickSearchService extends Service {
  @service
  router;

  search(query) {
    if (quickPayRegex.test(query)) {
      let [, amount, name] = query.match(quickPayRegex);
      this.router.transitionTo('admin.quick-payment', {
        queryParams: { amount, name, personId: null },
      });
    } else {
      this.router.transitionTo('search', { queryParams: { query: query } });
    }
  }
}
